module.exports = __webpack_public_path__ + "static/grid-e-07e1c7f160efc7e4df7adb8c6600cec9.jpg";